export default __webpack_public_path__ + "static/media/Megan_Whitaker_AHV_In_Moms_We_Trust.2d93f809.jpg";